import { FieldEnum } from 'Common/FieldEnum';

export const StudentInfoInitialValues = data => {
  return {
    [FieldEnum.Id]: data.Id,
    [FieldEnum.ServingNum]: data.ServingNum,
    [FieldEnum.SiteId]: data.SiteId,
    [FieldEnum.FirstName]: data.FirstName,
    [FieldEnum.LastName]: data.LastName,
    [FieldEnum.BirthDate]: data.BirthDate,
    [FieldEnum.Teacher]: data.Teacher,
    [FieldEnum.Grade]: data.GradeId,
    [FieldEnum.LanguageId]: data.LanguageId,
    [FieldEnum.StatusCurrent]: data.StatusCurrent,
    [FieldEnum.StatusPrevious]: data.StatusPrevious,
    [FieldEnum.BillingAcc]: data.BillingAcc,
    [FieldEnum.StateNum]: data.StateNum,
    [FieldEnum.NonLea]: data.NonLea,
    [FieldEnum.Message]: data.Message,
    [FieldEnum.Payments]: data.TotalPay
      ? data.TotalPay.toFixed(2)
      : data.TotalPay,
    [FieldEnum.Purchases]: data.TotalPurchase
      ? data.TotalPurchase.toFixed(2)
      : data.TotalPurchase,
    [FieldEnum.Balance]: data.Balance ? data.Balance.toFixed(2) : data.Balance,
    [FieldEnum.IdSeed]: data.IdSeed,
    [FieldEnum.StudentInfoImage]: true, //when removing the image, this will get changed and will flag dirty
    [FieldEnum.HomeRoom]: data.HomeRoom,
    [FieldEnum.FamilyIdentifier]: data.FamilyIdentifier,
    [FieldEnum.CEP_Transfer]: data.CEP_Transfer,
  };
};

export const StudentInfoSubmitObject = values => {
  return {
    Id: values[FieldEnum.Id],
    ServingNum: values[FieldEnum.ServingNum],
    SiteId: values[FieldEnum.SiteId],
    FirstName: values[FieldEnum.FirstName],
    LastName: values[FieldEnum.LastName],
    BirthDate: values[FieldEnum.BirthDate],
    GradeId: values[FieldEnum.Grade],
    LanguageId: values[FieldEnum.LanguageId],
    StatusCurrent: values[FieldEnum.StatusCurrent],
    StatusPrevious: values[FieldEnum.StatusPrevious],
    StatusFuture: values[FieldEnum.StatusFuture],
    Teacher: values[FieldEnum.Teacher],
    TotalPay: values[FieldEnum.Payments],
    TotalPurchase: values[FieldEnum.Purchases],
    Balance: values[FieldEnum.Balance],
    BillingAcc: values[FieldEnum.BillingAcc],
    StateNum: values[FieldEnum.StateNum],
    NonLea: values[FieldEnum.NonLea],
    Message: values[FieldEnum.Message],
    HomeRoom: values[FieldEnum.HomeRoom],
    FamilyIdentifier: values[FieldEnum.FamilyIdentifier],
    CEP_Transfer: values[FieldEnum.CEP_Transfer],
  };
};

export const StudentContactInfoInitialValues = data => {
  return {
    [FieldEnum.ParentFirstName]: data.HHFirstName,
    [FieldEnum.ParentLastName]: data.HHLastName,
    [FieldEnum.ShipAddress1]: data.Address1,
    [FieldEnum.ShipAddress2]: data.Address2,
    [FieldEnum.ShipCity]: data.City,
    [FieldEnum.ShipState]: data.State,
    [FieldEnum.ShipZipCode]: data.ZipCode,
    [FieldEnum.Email]: data.EMailId,
    [FieldEnum.ContactNumber]:
      data.Phone &&
      '(' +
        data.Phone.substr(0, 3) +
        ') ' +
        data.Phone.substr(3, 3) +
        '-' +
        data.Phone.substr(6, 4),
  };
};

export const StudentContactInfoSubmitObj = values => {
  return {
    HHFirstName: values[FieldEnum.ParentFirstName],
    HHLastName: values[FieldEnum.ParentLastName],
    Address1: values[FieldEnum.ShipAddress1],
    Address2: values[FieldEnum.ShipAddress2],
    City: values[FieldEnum.ShipCity],
    State: values[FieldEnum.ShipState],
    ZipCode: values[FieldEnum.ShipZipCode],
    EMailId: values[FieldEnum.Email],
    Phone:
      values[FieldEnum.ContactNumber] &&
      values[FieldEnum.ContactNumber].length > 0
        ? values[FieldEnum.ContactNumber].replace(/[^a-z0-9]+/g, '')
        : '',
  };
};

export const chargePermissionInitialValues = student => {
  const exists = student && student.Result ? true : false;

  return {
    [FieldEnum.ChargeFlag]: exists ? student.Result.Charge : null,
    [FieldEnum.AlaCarteExpense]: exists
      ? student.Result.AlaCarteExpense
      : false,
    [FieldEnum.AlaCarteAmount]: exists ? student.Result.AlaCarteExpAmount : '',
    [FieldEnum.AlaCarteExpFrequency]: exists
      ? student.Result.AlaCarteExpFrequency
      : null,
  };
};

export const chargePermissionSubmitObj = values => {
  const hasExpense = values[FieldEnum.AlaCarteExpense];

  return {
    Charge: values[FieldEnum.ChargeFlag],
    AlaCarteExpense: values[FieldEnum.AlaCarteExpense],
    AlaCarteExpAmount: hasExpense ? values[FieldEnum.AlaCarteAmount] : 0,
    AlaCarteExpFrequency: hasExpense
      ? values[FieldEnum.AlaCarteExpFrequency]
      : null,
  };
};



// WEBPACK FOOTER //
// ./src/pages/accountsetup/helpers/AccountSetupObjects.js